/**
 * Company 관련 타입 정의
 * #42: Company 타입을 @/types에서 import하여 통일
 * #187: company-list 타입 통합
 */

import type { Company } from '@/types';

// #42: Company 타입을 @/types에서 re-export
export type { Company } from '@/types';

// 언어 타입
export { type Language } from '@/config/locales';

// ────────────────────────────────────────────
// 전체 회사 관리 폼 (CompanyListPage용)
// ────────────────────────────────────────────

// 회사 폼 데이터 (등록/수정 시 사용, 전체 CFDI 필드 포함)
export interface CompanyFormData {
  name: string;
  rfc: string;
  address: string;
  phone: string;
  email: string;
  city: string;
  state: string;
  postalCode: string;
  taxRegime: string;
  cfdiUse: string;
}

// 번역 키 타입 (CompanyListPage용)
export interface CompanyTranslations {
  title: string;
  subtitle: string;
  addNewCompany: string;
  registeredCompanies: string;
  companyName: string;
  rfc: string;
  address: string;
  phone: string;
  email: string;
  city: string;
  state: string;
  register: string;
  cancel: string;
  rfcPlaceholder: string;
  phonePlaceholder: string;
  emailPlaceholder: string;
  selectCompany: string;
  noCompanies: string;
  addFirstCompany: string;
  required: string;
  companyRegistered: string;
  fillRequired: string;
  edit: string;
  delete: string;
  deleteConfirmTitle: string;
  deleteConfirmMessage: string;
  confirmDelete: string;
  companyDeleted: string;
  companyUpdated: string;
  editCompany: string;
  taxRegime: string;
  cfdiUse: string;
  postalCode: string;
  selectRegimen: string;
  selectUso: string;
  postalCodePlaceholder: string;
}

// 초기 폼 데이터
export const INITIAL_FORM_DATA: CompanyFormData = {
  name: '',
  rfc: '',
  address: '',
  phone: '',
  email: '',
  city: '',
  state: '',
  postalCode: '',
  taxRegime: '',
  cfdiUse: '',
};

// ────────────────────────────────────────────
// 세금계산서 회사 선택 모달 (TaxInvoiceModal용)
// (company-list에서 통합됨)
// ────────────────────────────────────────────

export interface CompanyListModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectCompany: (company: Company) => void;
}

// 간이 회사 등록 폼 데이터 (4개 필드만 사용)
export interface CompanyQuickFormData {
  name: string;
  rfc: string;
  address: string;
  email: string;
}

export interface FormErrors {
  [key: string]: string;
}

// 회사 선택 모달 번역 키
export interface CompanyListTranslations {
  selectCompany: string;
  addNewCompany: string;
  companyName: string;
  rfcNumber: string;
  address: string;
  email: string;
  save: string;
  cancel: string;
  back: string;
  selectForInvoice: string;
  addCompanyTitle: string;
  rfcRequired: string;
  companyRequired: string;
  addressRequired: string;
  defaultCompany: string;
}
